import { Box, Button, Grid, Stack, Typography } from "@compass/core";
import SignatureCanvas from "react-signature-canvas";

type FloatingHeaderProps = {
  text: string;
};

export const FloatingHeader = ({ text }: FloatingHeaderProps) => {
  return (
    <Stack
      sx={{ pointerEvents: "none" }}
      direction="row"
      alignItems="center"
      justifyContent="center"
      position="fixed"
      zIndex={999}
      top={0}
      width="95%"
      padding="50px"
    >
      <Typography color="error" variant="h4">
        {text}
      </Typography>
    </Stack>
  );
};
